import { render, staticRenderFns } from "./TagCascade.vue?vue&type=template&id=40e66cd5&scoped=true&"
import script from "./TagCascade.vue?vue&type=script&lang=js&"
export * from "./TagCascade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e66cd5",
  null
  
)

export default component.exports